import { Guid } from 'guid-typescript';

export class CheckPrevalidationErrors{
  static readonly type = '[SubmitCompanyHouse] Check Pre validation Errors';

  constructor(public id: any, public periodId: any) {}
}

export class GetSubmitAccountDetails{
  static readonly type = '[SubmitCompanyHouse] Get Submit Account Details';

  constructor(public id: any) {}
}
export class GetGatewayDetails {
  static readonly type = '[SubmitCompanyHouse] Get Gateway Details';

  constructor(public id: any) {}
}

export class PreviewHtmlReportFile {
  static readonly type = '[SubmitCompanyHouse] Preview Html Report File';

  constructor(public periodId:any,public id: any) {}
}

export class SubmitReport {
  static readonly type = '[SubmitCompanyHouse] Submit Report';

  constructor(public reportDetails: any) {}
}

export class GetSubmitMainGridDetails {
  static readonly type = '[SubmitCompanyHouse] Get Submit Main Grid Details';

  constructor(public periodId: any) {}
}

export class SubmitReportDownloadHTML {
  static readonly type = '[SubmitCompanyHouse] Get Submit Report Download HTML';

  constructor(public periodId: any, public id: any) {}
}

export class SubmitReportDownloadPDF {
  static readonly type = '[SubmitCompanyHouse] Get Submit Report Download PDF';

  constructor(public periodId: any, public submitId: any) {}
}

export class DeleteSubmittedFile {
  static readonly type = '[SubmitCompanyHouse] Delete Submitted File';

  constructor(public submitId: any) {}
}
export class ShowStatusMessage{
  static readonly type = '[SubmitCompanyHouse] Get Status Message';

  constructor(public id: any) {}
}